import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/MrdXmlAnalysisSelectors';

export class MrdXmlAnalysisContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLegendButton: true,
      // eslint-disable-next-line react/no-unused-state
      showModal: true,
    };
  }

  closeChart = () => {
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      showModal: false,
    });
  };

  render() {
    return (
      <Report
        reportId={ReportDefinitions.MRD_XML_ANALYSIS.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showLegendButton={this.state.showLegendButton}
        closeChart={this.closeChart}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

MrdXmlAnalysisContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(MrdXmlAnalysisContainer);
